import { Pipe } from '@angular/core';
import { PipeTransform } from '@angular/core';

@Pipe({ name: 'stringspliter' })
export class SplitPipe implements PipeTransform {
  transform(value: any) {
    if (value) {
      var lastFive = value.substr(value.length - 4);
      var trim = value.substring(0, value.length - 4);
      var res = trim.substring(0, 3);
      console.log(res + ' ' + lastFive);
      value = res + ' ' + lastFive;
    }
    return value;
  }
}
